export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-euro-a7c8e38180b796bea3805ddee1ee8835.svg";